import React from 'react';

/**
 * Render JSON-LD structured data in a script tag.
 */
export default function JsonLd({ data }) {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

// Les blocs Organization / SoftwareApplication vivent dans
// lib/seo/metadata.js (ORG_JSONLD, WEBSITE_JSONLD, SOFTWARE_APP_JSONLD),
// injectés côté serveur avec le reste du <head>. Il y avait ici une SECONDE
// Organization (autre logo, description en anglais) et un LegalService que
// personne ne montait : retirés le 02/09/2026.

export function createArticleSchema(article) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    image: article.ogImage || 'https://archer.law/og-image.png',
    datePublished: article.publishedAt,
    dateModified: article.updatedAt || article.publishedAt,
    author: {
      '@type': 'Person',
      name: article.author || 'Archer Legal Team',
      // Pas de `url` : elle pointait /about, une page qui n'existe dans
      // aucun routeur. Un lien mort annoncé à Google comme identité
      // éditoriale vaut moins que pas de lien du tout, et inventer la
      // page pour faire exister la cible n'était pas le sujet.
    },
    publisher: {
      '@type': 'Organization',
      name: 'Archer',
      logo: { '@type': 'ImageObject', url: 'https://archer.law/logos/archer-logo-wordmark.svg' },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://archer.law/blog/${article.slug}`,
    },
  };
}

export function createFaqSchema(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  };
}

export function createBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      ...(item.url ? { item: item.url } : {}),
    })),
  };
}
